import * as actionTypes from "../actionTypes";
import * as libraryServices from "../enums/libraryServices";
import contains from "../lib/contains";
import createReducer from "../lib/createReducer";
import find from "lodash.find";

const defaultState = {};

// eslint-disable-next-line import/namespace
const LIBRARY_SERVICES_ARR = Object.keys(libraryServices).map(key => libraryServices[key]);

const parseGroupLibrary = library => {
	const parsed = {
		currentLevel: library.current_level,
		currentUsers: library.current_users,
		maxUsers: library.max_users,
		name: library.name,
	};
	LIBRARY_SERVICES_ARR.filter(s => !!s).forEach(s => (parsed[s] = library[s]));
	return parsed;
};

function GROUPS_SET_USERS(state, action) {
	const { userIds, groupId } = action;

	if (!userIds || groupId === null || groupId === undefined) {
		return state;
	}

	return {
		...state,
		[groupId]: {
			...state[groupId],
			userIds,
		},
	};
}

function GROUPS_REMOVE_USERS(state, action) {
	const { removedIds, groupId } = action;
	if (!removedIds || groupId === null || groupId === undefined) {
		return state;
	}

	const group = state[groupId];
	if (!group) {
		return state;
	}

	const userIds = state[groupId].userIds;
	if (!userIds) {
		return state;
	}

	return {
		...state,
		[groupId]: {
			...group,
			userIds: userIds.filter(id => contains(removedIds, id) === false),
		},
	};
}

function GROUPS_ADD_USER(state, action) {
	const { groupId, user } = action;

	if (groupId === null || groupId === undefined || user === null || user === undefined) {
		return state;
	}

	const userId = user.id;
	if (userId === null || userId === undefined) {
		return state;
	}

	const group = state[groupId];

	if (group && find(group.userIds, id => id === userId)) {
		return state;
	}

	if (!group || !group.libraries) {
		const userIds = group && group.userIds ? [...group.userIds, userId] : [userId];
		return GROUPS_SET_USERS(state, { userIds, groupId });
	}

	const userIds = group.userIds ? [...group.userIds, userId] : [userId];
	let nextState = GROUPS_SET_USERS(state, { userIds, groupId });

	const userActivePracticeAreas = user.practice_areas.filter(pa => pa.active);
	if (!userActivePracticeAreas.length) {
		return nextState;
	}

	let libraryCountChanged = false;
	const libraries = group.libraries.map(library => {
		const userAddedToLibrary = find(userActivePracticeAreas, pa => pa.name === library.name);
		if (!userAddedToLibrary) {
			return library;
		}
		libraryCountChanged = true;
		return {
			...library,
			currentUsers: library.currentUsers + 1,
		};
	});

	if (libraryCountChanged) {
		nextState = GROUPS_UPDATE_LIBRARIES(nextState, { groupId, libraries });
	}
	return nextState;
}

function GROUPS_SET_DATA(state, action) {
	const { groupId, managerEmails, libraries, disable_generative } = action;

	if (!managerEmails || groupId === null || groupId === undefined || !libraries) {
		return state;
	}

	return {
		...state,
		[groupId]: {
			...state[groupId],
			managerEmails,
			libraries: libraries.map(parseGroupLibrary),
			disable_generative,
		},
	};
}

function GROUPS_UPDATE_LIBRARIES(state, action) {
	const { groupId, libraries } = action;

	if (groupId === null || groupId === undefined) {
		return state;
	}

	const group = state[groupId];
	if (!group || !group.libraries) {
		return state;
	}

	return {
		...state,
		[groupId]: {
			...group,
			libraries,
		},
	};
}

function GROUPS_UPDATE_LIBRARY_SERVICE(state, action) {
	const { groupId, libraryName, service, active } = action;

	if (groupId === null || groupId === undefined || !libraryName || !service) {
		return state;
	}

	const group = state[groupId];
	if (!group || !group.libraries) {
		return state;
	}

	let found = false;
	const libraries = [];
	group.libraries.forEach(library => {
		if (library.name !== libraryName) {
			libraries.push(library);
		} else {
			found = true;
			const nextLibrary = { ...library };

			if (active === null || active === undefined) {
				delete nextLibrary[service];
			}

			nextLibrary[service] = active;
			libraries.push(nextLibrary);
		}
	});

	if (!found) {
		return state;
	}

	return {
		...state,
		[groupId]: {
			...group,
			libraries,
		},
	};
}

const handlers = {};
handlers[actionTypes.USERS_SET] = GROUPS_ADD_USER;
handlers[actionTypes.GROUPS_REMOVE_USERS] = GROUPS_REMOVE_USERS;
handlers[actionTypes.GROUPS_SET_USERS] = GROUPS_SET_USERS;
handlers[actionTypes.GROUPS_SET_DATA] = GROUPS_SET_DATA;
handlers[actionTypes.GROUPS_UPDATE_LIBRARIES] = GROUPS_UPDATE_LIBRARIES;
handlers[actionTypes.GROUPS_UPDATE_LIBRARY_SERVICE] = GROUPS_UPDATE_LIBRARY_SERVICE;

export default createReducer(defaultState, handlers);
